import GenerateExcelConfig from "./GenerateExcelConfig";

export default class GenerateExcelService {
	static generateExcel(type, dateFrom, dateTo) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = GenerateExcelConfig.endpoint + "?type=" + type;
				if (dateFrom) endpoint += "&dateFrom=" + dateFrom;
				if (dateTo) endpoint += "&dateTo=" + dateTo;
				let response = GenerateExcelConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static generateExcelById(type, id) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					GenerateExcelConfig.endpointById + "?type=" + type + "&id=" + id;
				let response = GenerateExcelConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static downloadFile(fileName) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = GenerateExcelConfig.endpointTmp;
				endpoint += `/${fileName}`;
				let response = await GenerateExcelConfig.APIConnector.get(endpoint, {
					downloadFlag: true
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static generateExcelCompaniesNotRegistered() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = GenerateExcelConfig.endpointCompaniesNotRegistered;
				let response = GenerateExcelConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static generateExcelAffiliatesPerCity() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = GenerateExcelConfig.endpointAffiliatesPerCity;
				let response = GenerateExcelConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/GenerateExcel/GenerateExcelService.js